<template>
  <v-sheet v-if="callForPrice" class="px-2 text-caption my-1" rounded="lg" outlined>
    CALL FOR PRICE
  </v-sheet>
  <div v-else class="text-h6 font-weight-regular">
    {{ this.price }}
  </div>
</template>

<script>
export default {
  props: ['price'],
  computed: {
    callForPrice() {
      return this.price.toLowerCase().includes("call") || !this.price.includes("$")
    },
    classes() {
      return {
        "text-button" : this.callForPrice,
        "text-subtitle-1 font-weight-medium py-1": !this.callForPrice,
      }
    }
  }
}
</script>
